import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegrasCteComponent } from './regras-cte.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { RegrasCteEditComponent } from './regras-cte-edit/regras-cte-edit.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PoModule,
    PoPageDynamicTableModule,
    PoPageDynamicEditModule,
  ],
  declarations: [RegrasCteComponent, RegrasCteEditComponent]
})
export class RegrasCteModule { }
